import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import type { FC } from "react";

/** Asks before duplicating an asset; Duplicate shows it's working while the copy is made. */
export const DuplicateAssetDialog: FC<{
  asset: { title: string; content_type: string };
  open: boolean;
  duplicating?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}> = ({ asset, open, duplicating = false, onClose, onConfirm }) => (
  <Dialog open={open} onClose={duplicating ? undefined : onClose}>
    <DialogTitle>Duplicate {asset.title}?</DialogTitle>
    <DialogContent>
      This will duplicate the {asset.content_type === "Uploaded File" ? "file" : "design"} in your
      Content Library.
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        data-analytics-id="asset-duplicate-cancel"
        variant="text"
        disabled={duplicating}
      >
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        data-analytics-id="asset-duplicate-confirm"
        variant="contained"
        loading={duplicating}
      >
        Duplicate
      </Button>
    </DialogActions>
  </Dialog>
);
